<template>
  <div>
    <b-row>
      <b-col md="6">
        <b-card no-body>
          <div class="card-smallHeader">
            <i class="fa fa-justify mr-2"></i>
            <strong>Prestations</strong>
          </div>
          <b-card-body>
            <table class="table table-bordered">
              <tbody>
              <tr>
                <td class="center" style="width: 20%"><b>Fiches Niv. 2 < 3 mois</b></td>
                <td style="width: 20%">
                  <a v-if="!loadingFiche" :href="getSrc('fiche')" target="_BLANK">{{ ficheNiv2Prestations }} fiches</a>
                  <loading-field v-if="loadingFiche" />
                </td>
              </tr>
              <tr>
                <td class="center" style="width: 20%"><b>Décomptes IJ < 3 mois</b></td>
                <td style="width: 20%" @click="searchDecompte()">
                  <span class="clickable-link" v-if="!loadingDecompte">{{ decomptesIj }} décomptes</span>
                  <loading-field v-if="loadingDecompte" />
                </td>
              </tr>
              <tr>
                <td class="center" style="width: 20%"><b>Dossiers IJ < 3 mois</b></td>
                <td style="width: 20%" @click="searchDossiers('ij')">
                  <span class="clickable-link"> {{ countDossiers.DossierIJ }} dossier(s)</span>
                </td>
              </tr>
              <tr>
                <td class="center" style="width: 20%"><b>Dossiers Inval < 3 mois</b></td>
                <td style="width: 20%" @click="searchDossiers('inval')">
                  <span class="clickable-link"> {{ countDossiers.DossierInval }} dossier(s)</span>
                </td>
              </tr>
              <tr>
                <td class="center" style="width: 20%"><b>Dossiers Décès < 3 mois</b></td>
                <td style="width: 20%" @click="searchDossiers('dc')">
                  <span class="clickable-link"> {{ countDossiers.DossierDC }} dossier(s)</span>
                </td>
              </tr>
              </tbody>
            </table>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col md="6">
        <b-card no-body>
          <div class="card-smallHeader">
            <i class="fa fa-justify mr-2"></i>
            <strong>Entreprises</strong>
          </div>
          <b-card-body>
            <table class="table table-bordered">
              <tbody>
              <tr>
                <td class="center" style="width: 20%"><b>Fiches Niv. 2 < 3 mois</b></td>
                <td style="width: 20%">{{ ficheNiv2Entreprises }} fiches</td>
              </tr>
              <tr>
                <td class="center" style="width: 20%"><b>Utilisateurs Cev actifs</b></td>
                <td style="width: 20%">{{ userCevActiveCount }} utilisateur(s)</td>
              </tr>
              <tr>
                <td class="center" style="width: 20%"><b>MeP Contrats, hors gestion Etabl.</b></td>
                <td style="width: 20%">{{ mepContrat }} contrat(s)</td>
              </tr>
              <tr style="background-color: #979da4">
                <td class="center" style="width: 20%"><b>Demande démission</b></td>
                <td style="width: 20%">Non</td>
              </tr>
              <tr style="background-color: #979da4">
                <td class="center" style="width: 20%"><b>Renouvellement</b></td>
                <td style="width: 20%">Non</td>
              </tr>
              <tr style="background-color: #979da4">
                <td class="center" style="width: 20%"><b>Fusion</b></td>
                <td style="width: 20%">Non</td>
              </tr>
              </tbody>
            </table>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <span v-b-tooltip.hover.righttop="{ customClass: 'pre-formatted' }" :title="getTooltip()" id="tooltip-note">
        <img style="margin-top: 7%" class="clickable" :src="getIconSrc()" @click="editCommentaire()"/>
      </span>
    </b-row>

    <b-modal size="xl" scrollable id="modal-commentaire" ref="modal-commentaire" title="Commentaires">
      <b-row v-for="(commentaire,key) of commentairesActualitePilotage" class="align-items-center" :key="commentaire.id">
        <b-col md="10" style="display: inline-block;">
          <label>Commentaire
            <span class="smaller-2">
              <i>Dernière modification le {{ formatDateHeure(commentaire.updated_at) }} par {{ commentaire.gestionnaire.prenom }} {{ commentaire.gestionnaire.nom }}</i>
            </span>
          </label>
          <b-form-textarea
            :id="'commentaire-'+commentaire.id"
            v-model="commentaires[commentaire.id].texte"
            placeholder="Saisir un commentaire..."
            rows="3"
            max-rows="6"
            :class="{hasError: errors.commentaire !== '' && commentaires[commentaire.id].texte === ''}"
            disabled>
          </b-form-textarea>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12">
          <button v-if="addComHidden" type="button" title="Ajouter un commentaire"
                  class="btn btn-succes mr-1  pull-right" @click="addComHidden = false"><i
            class="fa fa-plus-circle fa-2x green" aria-hidden="true"></i></button>
        </b-col>
      </b-row>
      <b-row v-if="!addComHidden">
        <b-col md="10">
          <b-card no-body class="mt-3">
            <div class="card-smallHeader">
              <i class="fa fa-justify mr-2"></i>
              <strong>Ajouter un commentaire</strong>
            </div>
            <b-card-body>
              <b-form-group>
                <b-form-textarea
                  v-model="commentaireToAdd"
                  placeholder="Saisir un commentaire..."
                  rows="3"
                  max-rows="6"
                  :class="{hasError: errors.commentaire !== '' && commentaireToAdd === ''}">
                </b-form-textarea>
              </b-form-group>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
      <span class="field-error inline mr-1 float-right">{{ errors.commentaire }}</span>
      <template v-slot:modal-footer>
        <div class="w-100 text-right">
          <button type="button" class="btn btn-secondary mr-1" @click="closeModal()">Annuler</button>
          <button type="button" @click="saveCommentaire()" class="btn btn-primary"><i class="fa fa-save"></i>
            Enregistrer
          </button>
        </div>
      </template>
    </b-modal>

  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "@/utils/auth";
  import {isEmpty} from "@/utils/fileHelper";
  import loadingField from "@/components/LoadingField";
  import moment from 'moment';

  export default {
    name: "ActualitePilotage",
    components: {
      loadingField
    },
    data() {
      return {
        countDossiers: {},
        decomptesIj: 0,
        ficheNiv2Entreprises: 0,
        ficheNiv2Prestations: 0,
        mepContrat: 0,
        commentaires: [],
        commentairesActualitePilotage: [],
        commentairesOriginaux: [],
        addComHidden: true,
        commentaireToAdd: '',
        errors: {
          commentaire: ''
        },
        loadingFiche: true,
        loadingDecompte: true,
        allTraitements: [],
      }
    },
    props: [
      'ActualitePilotageDataSiren',
      'userCevActiveCount',
      'siren'
    ],
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common['Authorization'] = getIdToken() + ' ' + getAccessToken()
      this.$axios.defaults.headers.common['Accept'] = 'application/json'
      this.$axios.defaults.headers.common['Provider'] = getProvider()
      // this.siren = this.$route.params.siren;
      this.getAllTraitements();
      this.getCommentairePilotage();
      this.getDossiersCount();
      this.getDecomptesIjCount();
      this.getFicheNiv2EntreprisesCount();
      this.getFicheNiv2PrestationsCount();
      this.getMepContratCount();
    },
    methods: {
      getDossiersCount() {
        this.$axios.get('/espaceGestion/dossier/dossiersCountActualitePilotage/'+this.siren)
          .then((response) => this.countDossiers = response.data.data)
          .catch((error) => console.log(error));
      },
      getDecomptesIjCount() {
        this.loadingDecompte = true;
        this.$axios
          .get("/espaceGestion/siren/decomptesIjCount/"+this.siren)
          .then(response => {
            this.loadingDecompte = false;
            this.decomptesIj = response.data.result
          })
          .catch((error) => {
            this.loadingDecompte = false;
            console.log(error)
          });
      },
      getFicheNiv2EntreprisesCount() {
        this.$axios
          .get("/espaceGestion/siren/ficheNiv2Entreprises/"+this.siren)
          .then(response => this.ficheNiv2Entreprises = response.data.result)
          .catch((error) => console.log(error));
      },
      getFicheNiv2PrestationsCount() {
        this.loadingFiche = true;
        this.$axios
          .get("/espaceGestion/siren/ficheNiv2Prestations/"+this.siren)
          .then(response => {
            this.loadingFiche = false;
            this.ficheNiv2Prestations = response.data.result;
          })
          .catch((error) => {
            console.log(error)
            this.loadingFiche = false;
          });
      },
      getMepContratCount() {
        this.$axios
          .get("/espaceGestion/siren/mepContratSiren/"+this.siren)
          .then(response => this.mepContrat = response.data.result)
          .catch((error) => console.log(error));
      },
      getCommentairePilotage() {
        this.$axios
          .get("/espaceGestion/siren/getCommentairePilotage/"+this.siren)
          .then(response => {
            this.commentairesActualitePilotage = response.data.comments;
            this.setCommentaires(this.commentairesActualitePilotage);
          })
          .catch((error) => console.log(error));
      },
      validateCommentaires() {
        let error = false;
        for (let commentaireKey in this.commentaires[this.id]) {
          if (commentaireKey === undefined) {
            continue;
          }
          if (this.commentaires[this.id][commentaireKey].texte === '') {
            error = true;
            this.errors.commentaire = 'Vous ne pouvez pas enregistrer un commentaire vide';
          }
        }
        if (this.commentaireToAdd.trim() === '') {
          error = true;
          this.errors.commentaire = 'Vous ne pouvez pas enregistrer un commentaire vide';
        }
        return !error;
      },
      getTooltip() {
        let tooltip = '';
        for (let element of this.commentairesActualitePilotage) {
          if(!isEmpty(element)) {
            tooltip = tooltip + element.commentaire + '\n';
          }
        }
        return tooltip;
      },
      setCommentaires(allComments) {
        this.commentaires = [];
        this.commentairesOriginaux = [];
        for (let element of allComments) {
          if(!isEmpty(element)) {
            this.commentaires[element.id] = {
              texte: element.commentaire,
            }
            this.commentairesOriginaux[element.id] = {
              texte: element.commentaire,
            }
          }
        }
      },
      getIconSrc() {
        const images = require.context('@/assets/images/', false, /\.png$/);
        const icon = this.commentairesActualitePilotage.length === 0 ? 'post-it-no-note-26.png' : 'post-it-normal-26.png';
        return images('./' + icon);
      },
      formatDateHeure(textDate) {
        return textDate !== null ? new Date(textDate).toLocaleString("fr-FR") : "-";
      },
      editCommentaire() {
        this.errors.commentaire = '';
        this.$refs['modal-commentaire'].show();
      },
      saveCommentaire() {
        if (this.validateCommentaires()) {
          this.$store.commit('IS_LOADING', true);
          this.$axios
            .post("/espaceGestion/siren/addCommentairePilotage/"+this.siren, {
              'commentaire': this.commentaireToAdd,
            })
            .then((response) => {
              this.$store.commit('IS_LOADING', false);
              this.closeModal();
              this.commentairesActualitePilotage = response.data.comments;
              this.setCommentaires(this.commentairesActualitePilotage);
              this.$swal({
                position: "top",
                type: "success",
                title: "Succès !",
                text: 'Commentaire bien enregistré',
                showConfirmButton: false,
                timer: 3000
              });
            })
            .catch(function (error) {
              console.log(error);
              let textError = 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI';
              if (error.response.status === 400) {
                textError = 'Vous devez saisir un commentaire';
              }
              this.$store.commit('IS_LOADING', false);
              this.$swal({
                position: 'top',
                type: 'error',
                title: 'Attention !!',
                text: textError,
                showConfirmButton: false,
                timer: 5000
              });
            });
        }
      },
      closeModal() {
        this.$refs['modal-commentaire'].hide();
        this.remiseAZero();
      },
      remiseAZero() {
        this.errors.commentaire = '';
        this.addComHidden = true;
        this.commentaireToAdd = '';
        this.commentairesActualitePilotage = [];
      },
      getSrc(type) {
        const dgpoUrlBase = process.env.VUE_APP_DGPO_URL;
        let dateCalculee = new Date();
        dateCalculee.setMonth(dateCalculee.getMonth() - 2); // Les mois commencent à 0, donc pour enlever 3 mois il faut faire -2
        let urlDate = dateCalculee.getDate() + '/' + dateCalculee.getMonth() + '/' + dateCalculee.getFullYear();

        if (type === 'decompte') {
          // console.log(dgpoUrlBase + 'decompte/recherche/resultat?siren=' + this.siren + '&date_debut=' + urlDate)
          return dgpoUrlBase + 'decompte/recherche/resultat?siren=' + this.siren + '&date_debut=' + urlDate;
        }
        if (type === 'fiche') {
          return dgpoUrlBase + 'fiche/recherche/resultat?structure_siren=' + this.siren + '&date_debut=' + urlDate;
        }

        return '#';
      },
      searchDecompte() {
        this.$router.push({
          path: '/espace-gestion/decomptes-ij/list',
          query: {
            date_debut_decompte: moment().subtract(90, 'days').format("YYYY-MM-DD"),
            siren: this.siren,
          }
        })
      },
      searchDossiers(type) {
        let traitementId = null;
        if (type === 'ij') {
          traitementId = this.getTraitementIdByLibelleTehnique('ij_gestion_prestation');
        }
        if (type === 'inval') {
          traitementId = this.getTraitementIdByLibelleTehnique('gestion_inval');
        }
        if (type === 'dc') {
          traitementId = this.getTraitementIdByLibelleTehnique('gestion_dc');
        }
        if(traitementId !== null) {
          this.$router.push({
            path: '/espace-gestion/dossier',
            query: {
              traitementId: traitementId,
              dd: moment().subtract(90, 'days').format("YYYY-MM-DD"),
              siren: this.siren,
            }
          })
        }
      },
      getTraitementIdByLibelleTehnique(libelle_technique) {
        let treatment = _.find(this.allTraitements, function (element) {
          return element.libelle_technique === libelle_technique;
        });
        return treatment && treatment.id;
      },
      getAllTraitements() {
        this.$axios
          .get("/administration/traitements")
          .then(response => {
            this.allTraitements = response.data.traitements;
          });
      },
    }
  }
</script>

<style scoped>
  .pre-formatted {
    white-space: pre-line;
    max-width: 100% !important;
  }
  .clickable-link {
    cursor: pointer;
    color: #42aadd;
  }
  .clickable-link:hover {
    text-decoration: underline;
  }
</style>
